import { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { database } from "../utils/fipresConfig";
import { MagnifyingGlass } from "react-loader-spinner";
import ProjectData from "../components/dataForm/projectData";
export default function Project({ onDeleteClick, onEditClick }) {
  const [project, setProject] = useState([]);
  const [loading, setLoading] = useState(true); // تعيين حالة التحميل إلى true في البداية

  useEffect(() => {
    const collectionGet = collection(database, "books");
    const q = query(collectionGet, where("primaryKey", "==", "project"));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const projectData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setProject(projectData);
        setLoading(false); // تعيين حالة التحميل إلى false بعد اكتمال جلب البيانات
      },
      (error) => {
        setLoading(false); // تعيين حالة التحميل إلى false في حالة حدوث خطأ
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <div className="container_files">
      <section id='project' className='service'>
        <h2 className="titels">Project</h2>
        <div className="content">
          {loading ? (
            <span className="notes-pragraph__content--title"><MagnifyingGlass
            visible={true}
            height="80"
            width="80"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperClass="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#e15b64"             
             /></span>
          ) : (
            project.map((doc, index) => (
              <div key={index} className="file-item">
                <ProjectData
                  image={doc.image}
                  title={doc.title}
                  text={doc.text}
                  link={doc.link}
                  textLink={doc.textlink}
                  onEditClick={() => onEditClick(doc)}
                  onDeleteClick={() => onDeleteClick(doc.id)}
                />
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}